import './InfoBoxes.css';

import { PureComponent } from 'react';

import InfoBox from 'components/InfoBox';
import { makeSelectSnapshotInJobs } from 'containers/App/Header/JobManagement/selectors';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getElapsedTime } from '../helpers';
import { makeSelectContentSnapshot } from '../selectors';

class InfoBoxes extends PureComponent {
  static propTypes = {
    isRunning: PropTypes.bool.isRequired,
    msg: PropTypes.object.isRequired,
    selectedSnapshot: PropTypes.string,
    snapshot: ImmutablePropTypes.map,
    snapshotInJobs: ImmutablePropTypes.map,
  };

  state = {
    elapsedTime: 0,
  };

  componentDidMount() {
    this.startTimer();
  }

  componentDidUpdate(prevProps) {
    const { selectedSnapshot } = this.props;
    if (
      selectedSnapshot !== prevProps.selectedSnapshot ||
      this.state.elapsedTime <= 0
    ) {
      this.setState({ elapsedTime: 0 }, () => {
        this.updateTimeElapsed(true);
        this.startTimer();
      });
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  updateTimeElapsed = (init) => {
    const { snapshot, snapshotInJobs } = this.props;
    const tsEnd = snapshot?.get('ts');
    const action = snapshotInJobs?.getIn(['args', 'action']);
    const tsStart =
      action === 'refresh' || action === 'add'
        ? snapshotInJobs?.get('startedAt')
        : snapshot?.get('tsStart');
    if (!tsEnd) {
      return;
    }
    if (init && this.state.elapsedTime > 0) {
      return;
    }
    const seconds = Math.floor((tsEnd - tsStart) / 1000);
    this.setState({ elapsedTime: seconds });
  };

  startTimer() {
    this.stopTimer();
    if (!this.timer) {
      this.timer = setInterval(this.updateTimeElapsed.bind(this), 1000);
    }
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  render() {
    const { msg, isRunning, snapshot } = this.props;
    return (
      <div className='snapshots-info-box__column'>
        <InfoBox
          colorClass='aqua'
          colorizeOnlyIcon={false}
          iconClass={isRunning ? 'fa fa-arrows-rotate fa-spin' : 'fa fa-globe'}
        >
          <table className='snapshots-infobox float-right'>
            <thead>
              <tr>
                <td className='snapshots-infobox__cell snapshots-infobox__th w-1/4'>
                  {msg.discovery.timeElapsed}
                </td>
                <td className='snapshots-infobox__cell snapshots-infobox__th w-1/4'>
                  {msg.discovery.infoDiscovered}
                </td>
                <td className='snapshots-infobox__cell snapshots-infobox__th w-1/4'>
                  {msg.discovery.discoQueueProcessed}
                </td>
                <td className='snapshots-infobox__cell snapshots-infobox__th w-1/4'>
                  {msg.discovery.discoQueueRemaining}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='snapshots-infobox__cell'>
                  <span className='snapshots-infobox__number snapshots-infobox__center--big'>
                    {getElapsedTime(this.state.elapsedTime)}
                  </span>
                </td>
                <td className='snapshots-infobox__cell'>
                  <table>
                    <tbody>
                      <tr>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number snapshots-infobox__queue pr-2.5'>
                            {msg.discovery.total}
                          </span>
                        </td>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number snapshots-infobox__queue'>
                            {Number(
                              snapshot?.get('totalDevCount') || 0,
                            ).toLocaleString()}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number pr-2.5 pt-0'>
                            {msg.discovery.licensed}
                          </span>
                        </td>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number pt-0'>
                            {Number(
                              snapshot?.get('licensedDevCount') || 0,
                            ).toLocaleString()}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td className='snapshots-infobox__cell'>
                  <table>
                    <tbody>
                      <tr>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number snapshots-infobox__queue pr-2.5'>
                            {msg.discovery.addresses}
                          </span>
                        </td>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number snapshots-infobox__queue'>
                            {Number(
                              snapshot?.getIn(['vTask', 'processed']) || 0,
                            ).toLocaleString()}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number pr-2.5 pt-0'>
                            {msg.discovery.networks}
                          </span>
                        </td>
                        <td className='text-right'>
                          <span className='snapshots-infobox__number pt-0'>
                            {Number(
                              snapshot?.getIn(['vTraceCache', 'processed']) ||
                                0,
                            ).toLocaleString()}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td className='snapshots-infobox__cell'>
                  <span className='snapshots-infobox__number snapshots-infobox__queue inline-block'>
                    {Number(
                      snapshot?.getIn(['vTask', 'remains']) || 0,
                    ).toLocaleString()}
                    <br />
                    {Number(
                      snapshot?.getIn(['vTraceCache', 'remains']) || 0,
                    ).toLocaleString()}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </InfoBox>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  snapshot: makeSelectContentSnapshot(),
  snapshotInJobs: makeSelectSnapshotInJobs(),
});

export default connect(mapStateToProps)(InfoBoxes);
